
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"33","height":"33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"16.5","cy":"16.5","r":"14.5","fill":"#A6806F","stroke":"#fff","stroke-width":"3"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.289 16.723c.158-.117.665.24 1.242.736 1.243 1.071 2.694 2.266 2.806 2.342a55.379 55.379 0 011.938-2.625c1.438-1.813 2.978-3.54 4.818-5.017.33-.264.773-.517 1.219-.633a.554.554 0 01.321-.005c.162.052.172.182-.074.425a35.69 35.69 0 00-1.663 1.733c-2.1 2.378-3.685 5.042-4.972 7.861-.348.762-.66 1.102-1.418 1.204-.39.052-1.011-.23-1.212-.569-.927-1.57-2.862-4.874-2.889-4.948-.066-.186-.23-.421-.116-.504z","fill":"#020303"}}),_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"10","y":"11","width":"13","height":"12"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.289 16.723c.158-.117.665.24 1.242.736 1.243 1.071 2.694 2.266 2.806 2.342a55.379 55.379 0 011.938-2.625c1.438-1.813 2.978-3.54 4.818-5.017.33-.264.773-.517 1.219-.633a.554.554 0 01.321-.005c.162.052.172.182-.074.425a35.69 35.69 0 00-1.663 1.733c-2.1 2.378-3.685 5.042-4.972 7.861-.348.762-.66 1.102-1.418 1.204-.39.052-1.011-.23-1.212-.569-.927-1.57-2.862-4.874-2.889-4.948-.066-.186-.23-.421-.116-.504z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"fill":"#fff","d":"M-3.5-4.75h43.75V39H-3.5z"}})])])
          )
        }
      }
    